import { shardingPlugin } from './sharding_plugin'

export default shardingPlugin
